import {AnalyticsEventDataI, AnalyticsEventTypeI, AnalyticsProviderInterface} from '../analytics.provider.i';

declare let ga: any;

export class GoogleAnalyticsProvider implements AnalyticsProviderInterface {

    private ga: any = ga;

    constructor(token: string) {
        this.ga('create', token);
        console.log('Google analytics is enabled!');
    }

    trackEvent<T extends keyof AnalyticsEventTypeI>(event_type: T, event_data: any, cb?: () => void) {
        switch (event_type) {
            case 'pageview':
                this.ga('set', 'page', event_data);
                this.ga('send', 'pageview');
                break;

            case 'event':
                let _data: AnalyticsEventDataI = event_data;
                let analytic_event_data = {
                    hitType: 'event',
                    eventCategory: _data.category,
                    eventAction: _data.action,
                    eventLabel: _data.label || '',
                    eventValue: _data.value || null,
                };
                this.ga('send', analytic_event_data);
                break;

            case 'set_user_id':
                this.ga('set', 'userId', event_data || 0);
                break;

            default:
                break;
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/utils/analytics/providers/google.analytics.provider.ts